module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Vertical-8285d7194af7a6ffa61d011ae04e0ba0.svg";